import { initialPagination, initialState, makeListReducers } from '@/models/utils';
import { bindServices } from '@/services/api';
import CoreQueries from '@/utils/input/queries';
import { getFiltersConfig } from './utils';

const namespace = 'aiConsumption';
const api = bindServices(namespace);

const AiConsumptionModel = {
  namespace,
  state: {
    ...initialState,
    orderBy: 'created desc',
    filtersConfig: getFiltersConfig(),
  },
  effects: {
    *fetchData({ payload }, { call, put, select }) {
      try {
        const pagination = yield select((state) => state[namespace].pagination);
        const pageSize = yield select((state) => state.global.pageSize);
        const res = yield call(api.getAll, {
          route: payload.route ? payload.route : 'aiConsumption/paged',
          params: {
            limit: pageSize,
            ...CoreQueries.aiConsumption.paged,
            ...pagination,
            ...payload,
          },
          readPriority: true,
        });

        yield put({
          type: 'queryData',
          payload: { ...res, limit: pageSize, page: payload.page },
        });
      } catch (e) {}
    },

    *fetchItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'success', payload: false });
        const res = yield call(api.getById, {
          route: 'aiConsumption',
          id: payload.id,
          params: {
            ...(payload.detail ? CoreQueries.aiConsumption.itemDetail : {}),
            ...(payload?.params && { ...payload.params }),
          },
        });
        yield put({ type: 'queryItem', payload: res });
      } catch (e) {}
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'queryOrderBy',
        payload,
      });
    },

    *openDrawerView({ payload }, { put }) {
      yield put({
        type: 'queryOpenDrawerView',
        payload,
      });
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: {
        ...initialState,
        filtersConfig: getFiltersConfig(),
      },
    }),
    setFiltersConfig(state, { payload }) {
      return {
        ...state,
        filtersConfig: payload,
      };
    },
  },
};

export default AiConsumptionModel;
